import jsPDF from 'jspdf';

export const communicationExpUrl =
  'DataAnalysisReport/CommunicationExplorerReport';
export const conceptExpUrl = 'DataAnalysisReport/ConceptExplorer';
const getSVGWithStyles = (svg: SVGSVGElement) => {
  const clone: any = svg?.cloneNode(true);

  const inlineHtmlStyles = (source: any, target: any) => {
    const computed = window.getComputedStyle(source);
    const propsToCopy = [
      'display',
      'flex-direction',
      'justify-content',
      'align-items',
      'text-align',
      'color',
      'font-size',
      'text-anchor',
      'font-family',
      'font-weight',
      'width',
      'height',
      'fill',
      'margin',
    ];
    propsToCopy.forEach((prop) => {
      if (target.style) target.style[prop] = computed.getPropertyValue(prop);
    });
    for (let i = 0; i < source.children.length; i++) {
      inlineHtmlStyles(source.children[i], target.children[i]);
    }
  };

  const textOnBubble = svg?.querySelectorAll('text');
  const ClonedTextOnBubble = clone?.querySelectorAll('text');
  textOnBubble?.forEach((text, i) => {
    if (text) {
      inlineHtmlStyles(text, ClonedTextOnBubble[i]);
    }
  });

  const originalFos = svg?.querySelectorAll('foreignObject');
  const clonedFos = clone?.querySelectorAll('foreignObject');

  originalFos?.forEach((fo, i) => {
    const foStyle = window.getComputedStyle(fo);
    clonedFos[i].setAttribute('width', foStyle.width);
    clonedFos[i].setAttribute('height', foStyle.height);
    if (fo.firstElementChild) {
      inlineHtmlStyles(fo.firstElementChild, clonedFos[i].firstElementChild);
    }
  });
  return clone;
};

export const svgToPdfDownload = async (
  svgRef: React.RefObject<SVGSVGElement | null>
) => {
  if (!svgRef.current) return;

  const svgElement = svgRef.current as SVGSVGElement;
  const svgWithStyles = getSVGWithStyles(svgElement);

  const serializer = new XMLSerializer();
  let source = serializer.serializeToString(svgWithStyles);

  if (!source.match(/^<svg[^>]+xmlns="/)) {
    source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
  }

  const svgBase64 = btoa(
    new TextEncoder()
      .encode(source)
      .reduce((data, byte) => data + String.fromCharCode(byte), '')
  );
  const image64 = `data:image/svg+xml;base64,${svgBase64}`;

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = image64;

  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(img, 0, 0);

    const pngData = canvas.toDataURL('image/png');

    // Create a new jsPDF instance
    const pdf = new jsPDF({
      orientation: img.width > img.height ? 'landscape' : 'portrait',
      unit: 'pt',
      format: [img.width, img.height],
    });

    // Add custom header: "Data as of: 2025/12/05 08:45:07 UTC"
    const currentDate = new Date().toISOString().replace(/-/g, '/'); // ISO format: 2025/12/05T08:45:07Z
    const formattedDate = `Data as of: ${currentDate.replace('T', ' ').slice(0, 19)} UTC`;
    pdf.setFontSize(12); // Set the font size for the header
    pdf.text(formattedDate, 20, 20); // Add header text at position (20, 20)

    // Add the SVG image to the PDF
    pdf.addImage(pngData, 'PNG', 0, 40, img.width, img.height); // Start the image below the header (at y = 40)

    // Save the PDF
    pdf.save('network-graph.pdf');
  };
};
